import { cx } from "../../utils";

export const ImageSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={cx("animate-pulse rounded bg-alpha-100", className)} />
  );
};
